<section>

    <img src="assets/shapes/ellipse1.png" class="yc-circle1" />
    <img src="assets/shapes/ellipse2.png" class="yc-circle2" />
    <img src="assets/shapes/ellipse3.png" class="yc-circle3" />
    <img src="assets/shapes/ellipse4.png" class="yc-circle4" />

    <div class="Card-Login">
        <img src="assets/logo/yalocobro-logo.svg">
        <p class="body-small">Ingresa tus <b>credenciales</b> para ingresar al <br> <b>Portal de Administración</b></p>

        <form [formGroup]="loginForm" (keydown.enter)="onSubmit()">

            <div class="yc-input flex-1 w-full my-4" data-float data-icon>
                <input type="text" (input)="onInput($event, 'username')"
                  class="body-medium" formControlName="username" placeholder="Usuario" autocomplete="username">
                <label>Usuario</label>
            </div>

            <div class="password-sign-in w-full my-4">
                <div class="yc-select-input flex-col w-full" style="gap: 0 !important; align-items: end !important;" >
                    <div class="password-input w-full" style="gap: 0 !important;">
                        <div class="yc-input">
                            <input 
                            id="password" 
                            formControlName="password"    
                            [type]="!ojoAbierto ? 'text' : 'password'" 
                            (input)="onInput($event, 'password')" 
                            style="padding-right: 40px" 
                            placeholder="Password" 
                            class="form-control"
                            autocomplete="current-password"
                          >
                            <label for="input" class="in-label ">Contraseña</label>
                        </div>
                        <i class="ri-eye-line yc-password-icon"  (click)="ojoAbierto = false" *ngIf="ojoAbierto"></i>
                        <i class="ri-eye-off-line yc-password-icon"  (click)="ojoAbierto = true" *ngIf="!ojoAbierto"></i>
                    </div>
                    <div (click)="presentOlvidePassword()" class="forgot-password-input in-helper-text" >Olvidé mi contraseña</div>
                </div>
            </div>
           
            <yalo-button (click)="onSubmit()" [disabled]="!loginForm.valid" type="primary" text="medium">Iniciar sesión
            </yalo-button>

        </form>

        <p (click)="irCrearCuenta()" class="body-small cursor">¿Aún no tiene cuenta? <span
                class="button-default-text">Crear una cuenta</span></p>

        <div class="cursor" (click)="irCentroAyuda()">
            <i class="ri-question-line"></i>
            <p class="button-default-text">Centro de ayuda</p>
        </div>

    </div>

</section>